<template>
  <div class="tip">
    <el-dialog
      title="选择材料"
      :visible="dialogVisible"
      width="80%"
      max-height="250"
      :before-close="clear"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div
        class="filter-container"
      >
        <el-input
          v-model="listQuery.Keywords"
          placeholder="请输入关键字"
          style="width: 200px;"
          class="filter-item"
          clearable
          @keyup.enter.native="handleFilter"
          @clear="handleClear"
        />
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          size="small"
          @click="handleFilter"
        >
          搜索
        </el-button>
      </div>
      <el-table
        ref="cateringFlavorTable"
        :key="tableKey"
        v-loading="listLoading"
        :data="list"
        border
        stripe
        fit
        highlight-current-row
        style="width: 100%;"
        :row-key="currentRowKey"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClickChoose"
      >
        <el-table-column
          label="选择"
          type="selection"
          width="55"
          :selectable="handleSelectable"
          :reserve-selection="true"
        />
        <el-table-column label="口味组名称" prop="name" align="center" width="150">
          <template slot-scope="{row}">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="口味项" prop="flavorNames" align="left">
          <template slot-scope="{row}">
            <span>{{ row.flavorNames }}</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.num" @pagination="getTableList" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">取消</el-button>
        <el-button type="primary" @click="sure">选择</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { getIntroduction, getCurrnetMerchant } from '../../utils/auth'

let that
import { getCateringFlavorListInChoose } from '@/api/global'
import waves from '@/directive/waves' // waves directive
import { parseTime } from '@/utils'
import Pagination from '@/components/Pagination'
import NP from 'number-precision'
import _ from 'lodash'
const repairZero = (num) => {
  return num < 10 ? '0' + num : num
}

export default {
  name: 'ChooseCateringFlavorDialog',
  components: { Pagination },
  directives: { waves },
  filters: {
    timeFilter(time) {
      var date = new Date(time)
      return date.getFullYear() + '-' + repairZero(date.getMonth() + 1) + '-' + repairZero(date.getDate())
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    addCateringFlavorData: {
      type: Array,
      // eslint-disable-next-line
      default: []
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        num: 10,
        sort: 'addTime',
        Keywords: '',
        MerchantID: '',
        IsRequired: '',
        IsDiscount: '',
        IsMultiple: ''
      },

      options: [
      ],

      props: {
        value: 'id', // ID字段名
        label: 'name', // 显示名称
        children: 'children' // 子级字段名
      },
      loading: false,
      companys: [],

      multipleSelection: []
      // checked: true, // 如果使用单选框,定义一个model值

    }
  },
  beforeCreate: function() {
    that = this
  },
  created() {
    const introduction = JSON.parse(getIntroduction())
    if (introduction.isAdmin === true) {
      console.log(getCurrnetMerchant(), 'getCurrnetMerchant')
      const currnetMerchant = getCurrnetMerchant() ? JSON.parse(getCurrnetMerchant()) : ''
      this.listQuery.MerchantID = currnetMerchant && currnetMerchant.id ? currnetMerchant && currnetMerchant.id : ''
    } else {
      this.listQuery.MerchantID = introduction.id
    }
    this.getTableList()
  },
  methods: {
    handleSelectable(row, index) {
      const addCateringFlavorData = this.addCateringFlavorData
      let selectable = true

      if (addCateringFlavorData.length > 0) {
        for (let i = 0; i < addCateringFlavorData.length; i++) {
          if (addCateringFlavorData[i].id === row.id) {
            selectable = false
            break
          }
        }
      }
      return selectable
    },
    handleSelectionChange(val) {
      console.log('val', val)
      this.multipleSelection = val
    },
    /* handleSelectionChange(row) {
      for (let i = 0; i < this.list.length; i++) {
        console.log(row.id, this.list[i].id)
        if (this.list[i].id === row.id) {
          console.log('azhixign')
          this.list[i].checked = true
        } else {
          this.list[i].checked = false
        }
      }
    },*/
    getTableList() {
      this.listLoading = true
      const { page, num, sort, asc, Keywords, MerchantID, IsRequired, IsDiscount, IsMultiple } = this.listQuery
      getCateringFlavorListInChoose(page, num, sort, asc, MerchantID, IsRequired, IsDiscount, IsMultiple, Keywords).then(response => {
        const res = response.data
        for (let i = 0; i < res.length; i++) {
          res[i].flavorNames = ''
          for (let j = 0; j < res[i].items.length; j++) {
            res[i].flavorNames += res[i].items[j].name
            res[i].flavorNames += '(¥'
            res[i].flavorNames += res[i].items[j].price
            res[i].flavorNames += ')'
            if (j < res[i].items.length - 1) {
              res[i].flavorNames += '，'
            }
          }
          res[i].flavorNames.substring(0, res[i].flavorNames.lastIndexOf('，'))
        }
        this.list = res
        this.total = response.total
        this.listLoading = false
      })
    },
    currentRowKey(row) {
      return row.id
    },
    handleResetFilter() {
      this.listQuery = Object.assign({}, this.listQuery, {
        Keywords: '',
        IsRequired: '',
        IsDiscount: '',
        IsMultiple: ''
      })
      this.$nextTick(() => {
        this.handleFilter()
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getTableList()
    },
    handleClear() {
      this.getTableList()
    },
    // 点击行
    handleRowClickChoose(row, column, event) {
      console.log('bbb')
      const addCateringFlavorData = this.addCateringFlavorData
      // 判断点的这行是否是传进来的材料 传进来的材料不让点
      let rowCanBeChoose = true
      for (let i = 0; i < addCateringFlavorData.length; i++) {
        if (addCateringFlavorData[i].id === row.id) {
          rowCanBeChoose = false
          break
        }
      }
      rowCanBeChoose && this.$refs.cateringFlavorTable.toggleRowSelection(row)
    },
    sortChange(data) {
      const { prop, order } = data
      if (order === 'ascending') {
        this.listQuery.sort = '+' + prop
      } else {
        this.listQuery.sort = '-' + prop
      }
      this.handleFilter()
    },
    resetTemp() {
      this.temp = {
        Keywords: '',
        IsRequired: '',
        IsDiscount: '',
        IsMultiple: ''
      }
    },

    clear() {
      this.$emit('clear', {
        dialogVisible: false
      })
    },

    sure() {
      if (this.multipleSelection.length > 0) {
        console.log(1, this.multipleSelection)
        const multipleSelection = this.multipleSelection
        const addCateringFlavorData = this.addCateringFlavorData
        const newAddCateringFlavorData = multipleSelection
        this.$emit('sure', {
          addCateringFlavorData: newAddCateringFlavorData,
          dialogVisible: false
        })
        this.$refs.cateringFlavorTable.clearSelection()
      } else {
        console.log(2)
        this.$emit('sure', {
          addCateringFlavorData: [],
          dialogVisible: false
        })
        this.$refs.cateringFlavorTable.clearSelection()
      }
    },

    resetData() {
      this.tableKey = 0
      this.list = []
      this.total = 0
      this.listLoading = true
      this.listQuery = {
        page: 1,
        num: 10,
        sort: 'id',
        keywords: '',
        category: '',
        companyID: '',
        asc: 'false',
        state: 1
      }

      this.options = [
      ]

      this.props = {
        value: 'id', // ID字段名
        label: 'code', // 显示名称
        children: 'children' // 子级字段名
      }
      this.loading = false
      this.companys = []

      this.multipleSelection = []
      // checked: true, // 如果使用单选框,定义一个model值

      this.scaleUnitList = []
      this.type = 1 // 预算id获取材料明细1/材料类别0
    }

    /* getSortClass: function(key) {
      const sort = this.listQuery.sort
      const sortstr = sort.substr(1)

      if (sortstr !== key) return ''
      return sort === `+${key}` ? 'ascending' : 'descending'
    }*/
  }
}
</script>

